import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "touristfinancials",
  inputs: [
    {
      name: "liquid_funds",
      label: "Liquid Funds",
      placeholder: " CAD$ 12550",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "expected_expenditure",
      label: "Expected Expenditure",
      placeholder: "3000/- CAD$ ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "sources_of_funds",
      label: "Sources of funds",
      placeholder: "Bank Statement,Fixed Deposits",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 200,
    },
    {
      label: "Do you have any financial supporter ?",
      type: InputType.InputCluster,
      cols: 2,
      fields: [
        {
          name: "name_of_supporter",
          label: "Name of financial supporter",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
        {
          name: "relationship_with_supporter",
          label: "Your relationship financial supporter",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
        {
          name: "funds_available",
          label: "Total amount of fund supporter can provide you?",
          placeholder: "400 CAD",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
      ],
    },
  ],
};

export default formFields;
